import React from 'react';
import { X } from 'lucide-react';

// Define the types for the component's props
interface CustomDialogProps {
  message: string | null; // message can be a string or null
  onConfirm: () => void;
  onCancel: () => void;
  showCancel?: boolean; // showCancel is optional and defaults to true if not provided
}

const CustomDialog: React.FC<CustomDialogProps> = ({
  message,
  onConfirm,
  onCancel,
  showCancel = true,
}) => {
  if (!message) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-6 md:p-8 max-w-sm w-full transform transition-all duration-300 scale-100 animate-jump-in">
        <p className="text-gray-800 text-lg mb-6 text-center font-bold">{message}</p>
        <div className="flex flex-col space-y-3">
          <button
            onClick={onConfirm}
            className="w-full py-3 px-6 rounded-full text-white font-bold bg-custom-gradient from-sky-400 to-cyan-400 hover:from-sky-500 hover:to-cyan-500 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            {showCancel ? 'はい' : 'OK'}
          </button>
          {showCancel && (
            <button
              onClick={onCancel}
              className="w-full py-3 px-6 rounded-full text-gray-700 font-bold bg-gray-200 hover:bg-gray-300 transition-all duration-300"
            >
              キャンセル
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomDialog;